<div class="text-center">
  <p class="text-slate-600 mb-1 text-sm sm:text-base">Hemos enviado un código OTP a:</p>
  <p class="font-bold text-slate-800 mb-4 text-base sm:text-lg break-all">{{ email() }}</p>
  <p class="text-slate-600 mb-5 text-sm sm:text-base">Por favor, ingrésalo a continuación.</p>

  <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
    <label for="otp" class="block text-sm font-medium text-[#172C41] mb-1 text-left">Código OTP</label>
    <input
      id="otp"
      type="text"
      formControlName="otp"
      placeholder="XXXXXX"
      maxlength="6"
      [disabled]="disabled()"
      class="w-full rounded-[4px] border border-gray-300 px-3 py-2 text-sm text-center tracking-[0.5em] focus:border-[#F99C1E] focus:ring-1 focus:ring-[#F99C1E] disabled:opacity-50 disabled:cursor-not-allowed"
    />
    @if (otpForm.get('otp')?.invalid && otpForm.get('otp')?.touched) {
      <small class="text-red-500 block mt-1 mb-3 text-left text-sm">
        Por favor, ingrese un código OTP válido (6 dígitos).
      </small>
    } @else {
      <div class="my-5"></div>
    }

    <button
      type="submit"
      [disabled]="otpForm.invalid || disabled()"
      class="w-full px-4 py-2 rounded-[4px] font-medium bg-[#F99C1E] text-white cursor-pointer transition-colors hover:bg-[#e08a12] disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Verificar OTP
    </button>

    <button
      type="button"
      (click)="onBackToEmail()"
      [disabled]="disabled()"
      class="w-full mt-3 px-4 py-2 rounded-[4px] font-medium border border-[#172C41] text-[#172C41] cursor-pointer transition-colors hover:bg-[#172C41]/5 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Volver a ingresar email
    </button>
  </form>
</div>
